/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Event Group" |
*
* @param {Edit_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_title = /** @type {((inputs?: Edit_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppe bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica gruppo eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать группу событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループを編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar grupo de eventos")
	return /** @type {LocalizedString} */ ("Edit Event Group")
});